import TpPage from './Page';

export default TpPage; 